// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import React from 'react'

const idRoot = 'maintenance-window-warning-message'

const MaintenanceWindowWarningMessage = () => (
  <>
    <p id={`${idRoot}-1`}>{'The system will go into Maintenance Mode at 1AM Eastern.'}</p>
    <p id={`${idRoot}-2`}>{'Please save all changes and do not start Analysis or Finalization.'}</p>
  </>
)

export default MaintenanceWindowWarningMessage
